<template>
  <div
    class="chat-item-wrap pointer"
    :class="{
      chating: isChating,
      active: menuOpening
    }"
    @click="emitEvent('changeChatUser')"
  >
    <div class="avatar-wrap">
      <fps-avatar
        :src="userProfile.avatar"
        :level="levelComputed"
        :dressup="dressup"
      />
      <div
        v-if="
          !isOfficeAccount &&
            info.customInfo &&
            userProfile.onlineTime === '在線'
        "
        class="online-circle"
      ></div>
    </div>
    <div class="info">
      <div class="nickname">
        <span>{{ userProfile.nick }}</span>
        <div v-if="isOfficeAccount" class="tag">官方</div>
        <div
          v-else
          class="userlevel-tag level-mg"
          :class="`level-${levelComputed}`"
        ></div>
      </div>
      <p class="user-message">{{ lastMessageSimpleText }}</p>
    </div>
    <div class="operation">
      <div class="set-friend-main" @click.stop>
        <UserRelation
          v-if="!isOfficeAccount"
          class="set-friend-content"
          :currentMasterId="userProfile.userID"
          :conversationID="info.conversationID"
          @menuSwitch="menuOpening = $event"
        />
      </div>
      <span v-if="info.unreadCount > 0" class="unread-count">{{
        info.unreadCount
      }}</span>
    </div>
  </div>
</template>

<script>
import UserRelation from '@/components/UserRelation';
import IM from '@/plugins/im';
import { mapGetters } from 'vuex';

export default {
  components: {
    UserRelation
  },
  props: {
    info: {
      type: Object,
      dafault() {
        return {
          lastMessage: {
            payload: {}
          },
          userProfile: {}
        };
      }
    },
    index: Number,
    isChating: Boolean,
    allowDelete: Boolean
  },
  data() {
    return {
      IM_Types: IM.TYPES,
      menuOpening: false
    };
  },
  computed: {
    ...mapGetters(['userInfo', 'adminUuid']),
    userProfile() {
      return this.info.userProfile;
    },
    levelComputed() {
      return this.userProfile.userLevel || 0;
    },
    showLevelFrame() {
      const { levelComputed } = this;
      return levelComputed && levelComputed > 5;
    },
    lastMessageSimpleText() {
      const lastMessage = this.info.lastMessage;

      if (lastMessage.type === this.IM_Types.MSG_TEXT) {
        return lastMessage.payload.text;
      }

      if (lastMessage.type === this.IM_Types.MSG_IMAGE) {
        return '[圖片]';
      }

      if (
        lastMessage.type === this.IM_Types.MSG_CUSTOM &&
        lastMessage.payload.description === 'gift'
      ) {
        if (lastMessage.fromAccount === this.userProfile.userID) {
          return '你收到了一份禮物';
        } else {
          return '你送出了禮物';
        }
      }
      if (
        lastMessage.type === this.IM_Types.MSG_CUSTOM &&
        lastMessage.payload.description === 'comment' &&
        lastMessage.fromAccount === this.userInfo.uuid
      ) {
        return '成功送出好評';
      }
      if (lastMessage.type === this.IM_Types.MSG_CUSTOM) {
        return lastMessage.payload.extension;
      }

      return '';
    },
    isOfficeAccount() {
      if (!this.info || !this.info.userProfile || !this.info.userProfile.userID)
        return false;
      return [
        'fpx666',
        this.$store.state.app.adminUuid,
        ...this.$store.state.app.systemUuid
      ].includes(this.info.userProfile.userID);
    },
    // 裝扮
    dressup() {
      if (
        this.info &&
        this.info.customInfo &&
        this.info.customInfo.Tag_Profile_Custom_pfpFrame
      ) {
        const { url, time } = JSON.parse(
          this.info.customInfo.Tag_Profile_Custom_pfpFrame
        );
        return url && new Date().getTime() < time ? url : null;
      } else {
        return null;
      }
    }
  },
  methods: {
    emitEvent(eventName) {
      this.$emit(eventName, this.info, this.index);
    }
  }
};
</script>

<style lang="scss" scoped>
.set-friend-content {
  visibility: hidden;
}
.chat-item-wrap {
  @include flex(flex-start);
  height: 80px;
  position: relative;
  .online-circle {
    position: absolute;
    border-color: #3e4557;
    right: 13px;
    bottom: 13px;
    z-index: 1;
  }

  &.active .set-friend-content {
    visibility: visible;
  }

  &:hover {
    background: #434a5c;
    .set-friend-content {
      visibility: visible;
    }
    .online-circle {
      border-color: #434a5c;
    }
  }

  &.chating {
    background: #292f3d;
    .online-circle {
      border-color: #292f3d;
    }
  }
}

.avatar-wrap {
  position: relative;
  width: 80px;
  height: 100%;
  border-radius: 100%;
  padding: 15px 10px 15px 20px;
}

.info {
  width: 162px;
  margin-left: 4px;
  color: white;
  p {
    font-size: 14px;
    line-height: 20px;
    width: 100%;
    @include ellipsis;
  }

  .user-message {
    opacity: 0.5;
  }

  .nickname {
    @include flex(flex-start);
    overflow: hidden;
    width: 100%;
    height: 22px;
    font-size: 16px;
    font-weight: 500;
    margin-bottom: 4px;
    span {
      @include ellipsis;
    }
    .tag {
      flex-shrink: 0;
      font-size: 11px;
      font-weight: 500;
      line-height: 16px;
      color: white;
      padding: 0 3px;
      background: #468bdd;
      border-radius: 2px;
      margin-left: 10px;
    }
    .userlevel-tag {
      margin-left: 4px;
    }
  }
}

.operation {
  @include flex(space-between, flex-end, column);
  height: 100%;
  img {
    width: 22px;
    height: 22px;
    cursor: pointer;
  }
  .unread-count {
    display: block;
    min-width: 19px;
    box-sizing: border-box;
    padding: 1px 6px;
    height: 19px;
    border-radius: 9.5px;
    margin-right: 10px;
    margin-bottom: 18px;
    color: white;
    font-weight: 500;
    font-size: 12px;
    display: flex;
    justify-content: center;
    align-items: center;
    background: #ea7bad;
  }
}

.set-friend-main {
  display: flex;
  align-items: center;
}
.set-friend {
  display: inline-block;
}
</style>
